/**
 * ListIndicators - Indicadores de loading e fim de lista.
 */
import React from 'react';

export const LoadingIndicator: React.FC = () => (
    <div className="flex items-center justify-center py-s4" role="status" aria-live="polite">
        <div className="flex items-center gap-s2 text-muted">
            <div className="size-4 animate-spin rounded-full border-2 border-primary border-t-transparent" aria-hidden />
            <span className="text-caption">Carregando mais...</span>
        </div>
    </div>
);

export const EndOfListIndicator: React.FC = () => (
    <div className="flex justify-center py-s3">
        <span className="text-caption text-muted">
            Todas as conversas carregadas
        </span>
    </div>
);
